import { canAccessRoute } from '@/router/access'
import { noExpireCheckPages } from '@/utils/consts'

export function resolveLoginNextPage ({ dashboardName, redirectPath, resolveRoute }) {
  let nextPage = { name: dashboardName }
  if (redirectPath) {
    const redirectRoute = resolveRoute({ path: redirectPath }).route
    if (redirectRoute && redirectRoute.name && !noExpireCheckPages.includes(redirectRoute.name) && canAccessRoute(redirectRoute)) {
      nextPage = { path: redirectPath }
    }
  }
  return nextPage
}
